import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
// import AuthGuard from 'utils/route-guard/AuthGuard';

const Learners = Loadable(lazy(() => import('views/learners')));
const SystemSettings = Loadable(lazy(() => import('views/system-settings')));

// dashboard routing
const DashboardAnalytics = Loadable(lazy(() => import('views/dashboard/Analytics')));
const Courses = Loadable(lazy(() => import('views/courses')));
const Profile = Loadable(lazy(() => import('views/profile')));
const DashboardLearners = Loadable(lazy(() => import('views/dashboard/Learners')));
const Analytics = Loadable(lazy(() => import('views/analytics')));
const Resources = Loadable(lazy(() => import('views/resources')));
const Invite = Loadable(lazy(() => import('views/invite')));

const Error404 = Loadable(lazy(() => import('views/error/Error404')));

const MainRoutes = {
    path: '/',
    errorElement: <Error404 />,
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/analytics',
            element: <Analytics />
        },
        {
            path: '/learners',
            element: <Learners />
        },
        {
            path: '/system-settings',
            element: <SystemSettings />
        },
        {
            path: '/dashboard',
            element: <DashboardLearners />
        },
        {
            path: '/dashboard/analytics',
            element: <DashboardAnalytics />
        },
        {
            path: '/courses',
            element: <Courses />
        },
        {
            path: '/resources',
            element: <Resources />
        },
        {
            path: '/invite',
            element: <Invite />
        },
        {
            path: '/my-profile',
            element: <Profile />
        }
    ]
};

export default MainRoutes;
